import React, { lazy } from 'react'
import { PDFPreviewGP } from '@account-root/procurement-react/src/components/PDFTemplate/PDFPreviewGP'

const PurchaseOrderListing = lazy(() =>
  import(
    '@account-root/procurement-react/src/containers/GeneralPurchaseModule/GeneralPOModule/PurchaseOrderListing'
  ).then(module => ({
    default: module.PurchaseOrderListing,
  }))
)

const GeneratePOFromPRFormV2 = lazy(() =>
  import(
    '@account-root/procurement-react/src/containers/GeneralPurchaseModule/GeneralPOModule/GeneratePOFromPRFormV2'
  ).then(module => ({
    default: module.GeneratePOFromPRFormV2,
  }))
)

const GeneratePOFromPRFormV4 = lazy(() =>
  import(
    '@account-root/procurement-react/src/containers/GeneralPurchaseModule/GeneralPOModule/GeneratePOFromPRFormV4'
  ).then(module => ({
    default: module.GeneratePOFromPRFormV4,
  }))
)

const PurchaseOrderDetail = lazy(() =>
  import(
    '@account-root/procurement-react/src/containers/GeneralPurchaseModule/GeneralPOModule/PurchaseOrderDetail'
  ).then(module => ({
    default: module.PurchaseOrderDetail,
  }))
)

const DirectPoForm = lazy(() =>
  import(
    '@account-root/procurement-react/src/containers/GeneralPurchaseModule/DirectPOModule/DirectPOForm'
  ).then(module => ({
    default: module.DirectPoForm,
  }))
)

const POForm = lazy(() =>
  import(
    '@account-root/procurement-react/src/containers/GeneralPurchaseModule/DirectPOModule/POForm'
  ).then(module => ({
    default: module.PurchaseOrderForm,
  }))
)

const POItemForm = lazy(() =>
  import(
    '@account-root/procurement-react/src/containers/GeneralPurchaseModule/DirectPOModule/POItemForm'
  ).then(module => ({
    default: module.PurchaseOrderItemForm,
  }))
)

const generalPORoutes = [
  {
    props: {
      exact: true,
      path: `/general-purchase/:CompanyID/generate-po-from-pr`,
    },
    component: <PurchaseOrderListing type="generate-po-from-pr" />,
  },
  {
    props: {
      exact: true,
      path: '/general-purchase/:CompanyID/generate-po-from-pr/add',
    },
    component: <GeneratePOFromPRFormV4 mode="add" />,
  },
  {
    props: {
      exact: true,
      path: '/general-purchase/:CompanyID/generate-po-from-pr/draft/:poID',
    },
    component: <GeneratePOFromPRFormV4 mode="edit" />,
  },
  {
    props: {
      exact: true,
      path: `/general-purchase/:CompanyID/generate-po-from-pr/:dpoID/:formMode`,
    },
    component: <POForm detailMode={'edit'} type="generate-po-from-pr" />,
  },
  {
    props: {
      exact: true,
      path: '/general-purchase/:CompanyID/generate-po-from-pr/resubmit',
    },
    component: <GeneratePOFromPRFormV4 mode="resubmit" />,
  },
  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/generate-po-from-pr/detail/:dpoID/view',
    },
    component: <PurchaseOrderDetail type="generate-po-from-pr" />,
  },
  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/generate-po-from-pr/generate-po-from-pr-pr-list',
    },
    component: <PurchaseOrderDetail />,
  },
  {
    props: {
      exact: true,
      path: `/general-purchase/:CompanyID/generate-po-from-pr/:POHeaderID/detail/preview`,
    },
    component: (
      <PDFPreviewGP
        accountType="/"
        docType="generate-po-from-pr"
        backPath="generate-po-from-pr"
      />
    ),
  },
  {
    props: {
      exact: true,
      path: `/general-purchase/:CompanyID/generate-po-from-pr/:formMode/po-item/:detailMode`,
    },
    component: <POItemForm type="generate-po-from-pr" />,
  },
  {
    props: {
      exact: true,
      path: `/general-purchase/:CompanyID/generate-po-from-pr/:dpoID/:formMode/po-item/:detailMode`,
    },
    component: <POItemForm type="generate-po-from-pr" />,
  },
  {
    props: {
      exact: true,
      path: `/general-purchase/:CompanyID/generate-po-from-pr/:formMode/po-item/:dpoItemID/:detailMode`,
    },
    component: <POItemForm type="generate-po-from-pr" />,
  },
  {
    props: {
      exact: true,
      path: `/general-purchase/:CompanyID/generate-po-from-pr/:dpoID/:formMode/po-item/:dpoItemID/:detailMode`,
    },
    component: <POItemForm type="generate-po-from-pr" />,
  },
]

export default generalPORoutes
